// Order lifecycle. Mirrors ProspectOrderStatus in svc-backend
// (db/models/prospect_orders.py).
export const ORDER_STATUSES = [
  "new",
  "triaged",
  "in_progress",
  "delivered",
  "closed",
  "cancelled",
] as const;

export const STATUS_LABELS: Record<string, string> = {
  new: "New",
  triaged: "Triaged",
  in_progress: "In progress",
  delivered: "Delivered",
  closed: "Closed",
  cancelled: "Cancelled",
};

// Chip colours live in the shared registry (utils/statusColors.ts, kind "order").
